<template>
  <div class="schedule-appointment">
    <h1>What day and time works best?</h1>
    <v-card-text>
      <v-text-field v-show="false" v-model="appointmentDetails.customerID" label="Customer ID" placeholder="123456" variant="outlined"></v-text-field>
      <v-text-field v-show="false" v-model="appointmentDetails.type" label="Appointment Type" placeholder="123456" variant="outlined"></v-text-field>
      <v-text-field v-show="false" v-model="appointmentDetails.routeID" label="Route ID" placeholder="123456" variant="outlined"></v-text-field>
      <v-date-picker :allowed-dates="allowedDates" :key="routeDates.join(',')" v-model="date"></v-date-picker>
      <p>Arrival window: {{ appointmentDetails.chosenTime }}</p>
      <v-radio-group v-model="appointmentDetails.chosenTime">
        <v-radio label="Morning (7:30-12:30)" value="morning"></v-radio>
        <v-radio label="Afternoon (12:30-5:30)" value="afternoon"></v-radio>
      </v-radio-group>
      <v-btn :disabled="isScheduleDisabled" color="primary" size="large" class="font-weight-bold" @click="scheduleAppointment">Next</v-btn>
    </v-card-text>
    <p v-if="dateStart">{{ dateStart }}</p>
    <p v-if="dateEnd">{{ dateEnd }}</p>
    <p v-if="error">{{ error }}</p>
    <!--<p v-if="date">{{ cleanSelectedDate }}</p>
    <p v-if="date">{{ chosenRoute }}</p>
    <p v-if="result">{{ result }}</p>
    <p v-if="place">{{ place }}</p>-->
  </div>
</template>

<script>
//import axios from 'axios';

export default {
  data() {
    // Dynamically set the API base URL depending on environment
    const apiBaseUrl = process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000'  // Local development
      : 'https://api.getpestcontrol.services'; // Production

    // Get the current date
    const now = new Date();

    // Calculate dateStart (2 days from now)
    const dateStart = new Date(now);
    dateStart.setDate(dateStart.getDate() + 2);

    // Calculate dateEnd (21 days from dateStart)
    const dateEnd = new Date(dateStart);
    dateEnd.setDate(dateEnd.getDate() + 21);

    return {
      apiBaseUrl, // Store API base URL dynamically
      appointmentDetails: {
        customerID: '',
        subscriptionID: '',
        type: 2664,
        routeID: 0,
        date: '',
        chosenTime: '',
        callAhead: 30,
        start: '',
        end: ''
      },
      place: null,
      result: null,
      error: null,
      routes: JSON.parse(localStorage.getItem('mission-routes')) || [], // TODO: do we need this after dev? trying to save api hits..
      date: null,
      chosenRoute: null,
      appointmentResponse: { // TODO: should this still be here? I'm thinking no?
        requestAction: 'create',
        endpoint: 'appointment',
        success: true,
        processingTime: '458 milliseconds',
        count: 1,
        result: '14373326',
        propertyName: 'result',
        date: '2024-02-19'
      }
    }
  },
  mounted() {
    // do a thing
  },
  computed: {
    routeDates() {
      //console.log('routeDates recomputed', this.routes.map(route => route.date));
      return this.routes.map(route => route.date);
    },
    allowedDates() {
      return val => {
        const formattedDate = this.formatDate(val);
        //console.log(`Checking date: ${formattedDate}, Allowed: ${this.routeDates.includes(formattedDate)}`); // Debug log
        return this.routeDates.includes(formattedDate);
      };
    },
    cleanSelectedDate() {
      //console.log('cleanSelectedDate recomputed');
      return (this.date ? this.formatDate(this.date) : null);
    },
    isScheduleDisabled() {
      return !this.appointmentDetails.routeID; // Disable button if routeID is empty & arrival window isn't chosen
    }
  },
  props: {
    receivedPlace: Object,
    receivedCustomer: Object,
    receivedRoutes: Object,
  },
  watch: {
    receivedPlace: {
      handler(newValue) {
        console.log('receivedPlace changed:', newValue);
        if (newValue) {  // check that receivedPlace is defined
          this.place = newValue;
          //this.getRoutes();
        }
      },
      immediate: true, // Immediately run the handler upon mounting
      deep: true,  // enable deep watching if receivedPlace is a complex object
    },
    receivedCustomer: {
      handler(newValue) {
        console.log('receivedCustomer changed:', newValue);
        if (newValue) {  // check that receivedCustomer is defined
          this.appointmentDetails.customerID = newValue.customerID;
        }
      },
      immediate: true, // Immediately run the handler upon mounting
      deep: true,  // enable deep watching if receivedCustomer is a complex object
    },
    receivedRoutes: {
      handler(newValue) {
        if (newValue) {
          this.routes = newValue;
          console.log("this.routes:");
          console.log(this.routes);
        }
      },
      immediate: true, // Immediately run the handler upon mounting
      deep: true,  // enable deep watching if receivedRoutes is a complex object
    },
    date(newValue) {
      if (newValue && this.place) {
        // Call getClosestRoute when a new date is selected and place is available
        this.chosenRoute = this.getClosestRoute(
          this.routes,
          this.formatDate(newValue), // Ensure the date is in 'YYYY-MM-DD' format
          this.place.geometry.location.lat,
          this.place.geometry.location.lng
        );
        this.appointmentDetails.routeID = this.chosenRoute.routeID;
      } else {
        // Reset chosenRoute if no date is selected or place is not available
        this.chosenRoute = null;
      }
    },
    appointmentDetails: {
      handler(newVal) {
        if (newVal.chosenTime === 'morning') {
          newVal.start = '07:30';
          newVal.end = '12:30';
        } else if (newVal.chosenTime === 'afternoon') {
          newVal.start = '12:30';
          newVal.end = '17:30';
        } else {
          newVal.start = '';
          newVal.end = '';
        }
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      d.setUTCHours(0, 0, 0, 0); // Force the date to start at UTC midnight
      const month = `${d.getUTCMonth() + 1}`.padStart(2, '0');
      const day = `${d.getUTCDate()}`.padStart(2, '0');
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    getClosestRoute(routes, inputDate, inputLat, inputLng) {
      // Filter the routes to get only those that match the input date
      const filteredRoutes = routes.filter(route => route.date === inputDate);

      // Check if filteredRoutes is not empty
      if (filteredRoutes.length > 0) {
        // Find the route closest to the provided latitude and longitude
        const closestRoute = filteredRoutes.reduce((closest, route) => {
          // Calculate the distance for the current route
          const distance = Math.sqrt(
            Math.pow(route.averageLatitude - inputLat, 2) +
            Math.pow(route.averageLongitude - inputLng, 2)
          );

          // Calculate the distance for the closest route found so far
          const closestDistance = Math.sqrt(
            Math.pow(closest.averageLatitude - inputLat, 2) +
            Math.pow(closest.averageLongitude - inputLng, 2)
          );

          // Compare distances
          return (distance < closestDistance) ? route : closest;
        });

        // Return the closest route
        return closestRoute;
      }

      // Return null or an appropriate value indicating no match was found
      return null;
    },
    async scheduleAppointment() {
      try {
        this.appointmentResponse.date = this.cleanSelectedDate;
        this.appointmentDetails.date = this.cleanSelectedDate;
        localStorage.setItem('mission-appointment', JSON.stringify(this.appointmentDetails));
        this.$emit('send-appointment', this.appointmentDetails);
      } catch (error) {
        this.error = error.message;
      }
    },
  }
}
</script>